import { render } from "./DrugDetail.vue?vue&type=template&id=36dcbae2"
import script from "./DrugDetail.vue?vue&type=script&lang=js"
export * from "./DrugDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__